export class NotificationSetting {
  constructor(
    readonly name: string,
    readonly status: 'enabled' | 'disabled',
  ) {}
}
